import { render, staticRenderFns } from "./UserLoggedIn.vue?vue&type=template&id=3be949e7&scoped=true"
import script from "./UserLoggedIn.vue?vue&type=script&lang=js"
export * from "./UserLoggedIn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be949e7",
  null
  
)

export default component.exports